/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from './index-892d8eee.js';

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var aliMiniAppModule = (function () {
  var _dd, _my;

  return isDingdingMiniapp ? (_dd = dd).createIntersectionObserver.apply(_dd, arguments) : (_my = my).createIntersectionObserver.apply(_my, arguments);
});

function buildMarginStr(margins) {
  return (Number(margins.top) || 0) + "px " + (Number(margins.right) || 0) + "px " + (Number(margins.bottom) || 0) + "px " + (Number(margins.left) || 0) + "px";
}

function IntersectionObservers(options) {
  this.thresholds = options && options.thresholds ? options.thresholds : [0];
  this.initialRatio = options && options.initialRatio ? options.initialRatio : 0;
  this.selectAll = options && options.selectAll ? options.selectAll : false;

  this.callBack = function () {};

  this.observers = [];
}

function relative(root, self, margins) {
  var options = {
    root: root,
    rootMargin: margins ? buildMarginStr(margins) : '0px',
    threshold: self.thresholds
  };
  self.observers.push(new IntersectionObserver(function () {
    self.callBack.apply(self, arguments);
  }, options));
}

IntersectionObservers.prototype.relativeTo = function (selector, margins) {
  relative(document.querySelector(selector), this, margins);
  return this;
};

IntersectionObservers.prototype.relativeToViewport = function (margins) {
  relative(null, this, margins);
  return this;
};

IntersectionObservers.prototype.observe = function (targetSelector, callback) {
  var _this = this;

  if (this.selectAll) {
    var targets = document.querySelectorAll(targetSelector);
    targets.forEach(function (target) {
      return _this.observers.forEach(function (observer) {
        return observer.observe(target);
      });
    });
  } else {
    var target = document.querySelector(targetSelector);
    this.observers.forEach(function (observer) {
      return observer.observe(target);
    });
  }

  this.callBack = function (entries, observer) {
    entries.forEach(function (entry) {
      callback && typeof callback === 'function' && callback({
        boundingClientRect: entry.boundingClientRect,
        intersectionRatio: entry.intersectionRatio,
        intersectionRect: entry.intersectionRect,
        relativeRect: entry.rootBounds,
        time: entry.time
      });
    });
  };

  return this;
};

IntersectionObservers.prototype.disconnect = function (targetSelector, callback) {
  this.callBack = function () {};

  this.observers = [];
  this.observers.forEach(function (observer) {
    observer.disconnect();
  });
  return this;
};

var createIntersectionObserver$2 = function createIntersectionObserver(options, component) {
  return new IntersectionObservers(options);
};

var webModule = createIntersectionObserver$2;

var weChatModule = (function (options, context) {
  if (context === void 0) {
    context = wx;
  }

  if (options && options.selectAll != undefined) {
    options.observeAll = options.selectAll;
  } // 防止传入自定义组件的this没有createIntersectionObserver


  return context === wx || !context.createIntersectionObserver ? context.createIntersectionObserver(null, options) : context.createIntersectionObserver(options);
});

var bytedanceModule = (function (options, context) {
  if (context === void 0) {
    context = tt;
  }

  if (options && options.selectAll != undefined) {
    options.observeAll = options.selectAll;
  } // 防止传入自定义组件的this没有createIntersectionObserver


  return context === tt || !context.createIntersectionObserver ? context.createIntersectionObserver(null, options) : context.createIntersectionObserver(options);
});

var baiDuModule = (function (options, context) {
  if (context === void 0) {
    context = swan;
  }

  // 防止传入自定义组件的this没有createIntersectionObserver
  return context === swan || !context.createIntersectionObserver ? context.createIntersectionObserver(null, options) : context.createIntersectionObserver(options);
});

var createIntersectionObserver = function createIntersectionObserver() {
  if (isWeb) {
    return webModule.apply(void 0, arguments);
  } else if (isKuaiShouMiniProgram) {
    throw new Error('Uni API：IntersectionObserver暂不支持');
  } else if (isWeChatMiniProgram) {
    return weChatModule.apply(void 0, arguments);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.apply(void 0, arguments);
  } else if (isMiniApp) {
    return aliMiniAppModule.apply(void 0, arguments);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.apply(void 0, arguments);
  } else {
    throw new Error('Uni API：IntersectionObserver暂不支持');
  }
};

var createIntersectionObserver$1 = createIntersectionObserver;

export { createIntersectionObserver$1 as c };
